var app = angular.module('leonardo');

var PortfolioService = function(BaseRestService, RestangularProvider, $q) {
  var service = new BaseRestService('portfolios');

  // Override getlist to add graceful fallback for large ID lists
  var originalGetlist = service.getlist;
  service.getlist = function(options, noUpdated, noCancel) {
    var defer = $q.defer();
    
    originalGetlist.call(service, options, noUpdated, noCancel).then(
      function(results) {
        defer.resolve(results);
      },
      function(error) {
        // Graceful fallback: if GET fails with 400 (URL too long), retry with POST
        if (error && error.status === 400 && options && Object.keys(options).length > 0) {
          var filterOptions = angular.copy(options);
          delete filterOptions['disable_pagination'];
          filterOptions['disable_pagination'] = true;
          
          RestangularProvider.all('portfolios').customPOST({filters: filterOptions}, 'filters').then(
            function(results) {
              var portfolioList = results.results ? results.results : results;
              // Handle POST response - return in same format as GET
              var response = {
                results: portfolioList,
                count: results.count || portfolioList.length
              };
              service.setCollection(response);
              service.initialized = true;
              defer.resolve(response);
            },
            function(postError) {
              // POST also failed, reject with original error
              defer.reject(postError);
            }
          );
        } else {
          // Not a 400 error or no options, reject normally
          defer.reject(error);
        }
      }
    );
    
    return defer.promise;
  };

  service.getAvailableToAssign = function(params) {
    return RestangularProvider.all('portfolios').customGET('available-for-invitation', params);
  };

  service.getStatistics = function(params) {
    return RestangularProvider.all('portfolios').customGET('statistics', params);
  };

  return service;
};

app.factory('PortfolioService', ['BaseRestService', 'Restangular', '$q', PortfolioService]);
